export default "__VITE_ASSET__CaROGDYc__"